module.exports = "/packs/images/pages/membership/better_lido-desktop~0e0c49a8ba519d42ef27754b3cbc7621.jpg";